export default {"src":"/_next/static/media/page-not-found.4e645818.svg","height":316,"width":496,"blurWidth":0,"blurHeight":0};